export const exportToZipTranslations = {
  export_modal_cancel: 7862,
  export_modal_status_started: 7863,
  export_modal_status_pending: 7864,
  export_modal_submit: 7865,
  export_modal_comment: 7866,
  export_modal_description_1: 7868,
  export_modal_description_2: 7867,
  export_modal_title: 7869,
  export_modal_wait: 7948,
  export_success: 7873
};

export const endpoint = {
  exportCases: 'case/export',
  favouriteDefinition: 'favourite/definition/draft'
};
